<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="ion-text-center header-title">{{ 'PERSONAL_DATA.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/moj-profil']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>

       <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<!-- page content start -->
<ion-content class="bookings" *ngIf="me$ | async as me">
  <ion-grid fixed class="ion-no-padding">

  <ion-list class="user-info__items ion-no-padding">
    <ion-item class="no-padding" [routerLink]="['/moj-profil', 'osebni-podatki', 'ime']">
      <span>{{ 'PERSONAL_DATA.NAME' | translate }}</span>
       <span slot="end" class="data">{{me.firstName}} {{me.lastName}}</span>
      <!--div class="my-profile-notif">1</div-->
      <ion-icon class="arrow-right"></ion-icon>
    </ion-item>
    
    <ion-item class="no-padding" [routerLink]="['/moj-profil', 'osebni-podatki', 'telefon']">
      <span>{{ 'PERSONAL_DATA.PHONE' | translate }}</span>
      <span slot="end" class="data">{{ me.phone || '' | nationalFormat : 'SI'}}</span>
      <ion-icon class="arrow-right"></ion-icon>
    </ion-item>

    <ion-item class="no-padding">
      <span>{{ 'PERSONAL_DATA.EMAIL' | translate }}</span>
       <span slot="end" class="data">{{me.email}}</span>
      <!--ion-icon class="arrow-right"></ion-icon-->
    </ion-item>
    <!--ion-item no-padding>
      <span>Moje ocene</span>
      <ion-icon class="arrow-right"></ion-icon>
    </ion-item-->
  </ion-list>
  
  </ion-grid>
</ion-content>
<!-- page content end -->